import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loading from 'xpi-black-ui/Base/Loading';
import { LoadMenu, LoadOperations, UpdateOperationsFilters, SetOperationPageSelected } from '../../redux-flow/actions/operations';

import MainMenu from './compose/MainMenu';
import Container from './compose/Container';

// import menu from '../../redux-flow/logics/_mock';

const OperationsPage = ({ location }) => {
  const { pathname } = location;
  const dispatch = useDispatch();
  const [content, setContent] = useState({});
  const { menu, menuLoading, operations, operationsLoading, operationsLoadingError } = useSelector(({ Operation }) => Operation);

  // const dataPathname = useMemo(() => (pathname), [pathname]);

  useEffect(() => {
    if (menu?.length === 0) {
      dispatch(LoadMenu());
    }
  }, []);

  useEffect(() => {
    if (menu?.length > 0) {
      const menuSelected = onSetMenuSelected();
      getContent(menuSelected);
    }
  }, [menu, pathname]);

  const onSetMenuSelected = () => {
    let menuMatched = null;

    for (const menuItem of menu) {
      for (const submenu of menuItem.tiposOperacao) {
        if (pathname === submenu.link) {
          menuMatched = menuItem;
        }
      }
    }

    menuMatched = menuMatched || menu[0];

    if (menuMatched) {
      menuMatched = { ...menuMatched, pathname };
    }

    setContent({ ...content, menuSelected: menuMatched });
    return menuMatched;
  };

  const getCurrentPageId = (menuSelected) => {
    const submenuSelected = menuSelected?.tiposOperacao.filter(tipoOperacao => tipoOperacao.link === pathname);

    const submenuSelectedId = submenuSelected?.length > 0
      ? submenuSelected[0]?.id
      : menuSelected?.tiposOperacao[0]?.id;

    return `${menuSelected.id}-${submenuSelectedId}`;
  };

  const getCurrentContent = (menuSelected) => {
    const currentPageId = getCurrentPageId(menuSelected);

    if (currentPageId) {
      return operations.find(operationItem => operationItem?.id === currentPageId);
    }

    return null;
  };

  const getContent = (menuSelected) => {
    if (menuSelected) {
      const contentView = getCurrentContent(menuSelected);

      if (!contentView && !operationsLoadingError) {
        dispatch(LoadOperations({ menuSelected }));
      } else {
        setContent({
          ...contentView,
          menuSelected: {
            ...menuSelected,
          },
        });

        dispatch(SetOperationPageSelected({ pageId: contentView?.id }));
      }
    }
  };

  // const onApplyFilter = (filters) => {
  //   const pageId = getCurrentPageId(content?.menuSelected);

  //   dispatch(UpdateOperationsFilters({
  //     pageId,
  //     filters,
  //     menuId: content.menuSelected.id,
  //   }));
  // };

  return (
    <>
      {menu?.length > 0 && (
        <MainMenu
          menu={menu}
          menuSelected={content?.menuSelected}
        />
      )}

      <Container
        routePathname={location.pathname}
        isOperationDispatchLoading={operationsLoading}
      />

      {menuLoading && <Loading fixed text="Carregando..." />}
    </>
  );
};

export default OperationsPage;
